
export enum EcmGoalTypeCd {
	STD_GOAL = 'StdGoal',
	WEEKLY_GOAL = 'WeeklyGoal'}

